import { useEffect, useMemo, useRef } from 'react';
import { useGTM } from '../../../hooks';
import { buildPwaError } from '../../../utils/error-utils';
import type { PwaError } from '../interfaces/PwaError';

export function useErrorReport(error: PwaError, path: string): void {
    const { onPwaError } = useGTM();

    const errorData = useMemo(() => buildPwaError(error), [error, path]);
    const prevErrorRef = useRef<string | null>(null);

    useEffect(() => {
        if (prevErrorRef.current !== JSON.stringify(errorData)) {
            prevErrorRef.current = JSON.stringify(errorData);
            onPwaError(errorData);
        }
    }, [onPwaError, errorData]);
}
